import ListList from './ListList';
import ListCreate from './ListCreate';
import ListDetail from './ListDetail';

const routes = [
  {
    index: true,
    element: <ListList />,
  },
  {
    path: 'new',
    element: <ListCreate />,
  },
  {
    path: ':id',
    element: <ListDetail />,
  },
];

export default routes;
export { ListList, ListCreate, ListDetail };
